// ChatComponent.js
import React, { useState } from 'react';
import '../Chatbox/Chat.css'
import { IoLogoWhatsapp } from "react-icons/io";
import { MdOutlineWifiCalling3 } from "react-icons/md";
const Chat = () => {
  const [messages, setMessages] = useState([]);
  const [inputText, setInputText] = useState('');

 
  const handleWhatsAppClick = () => {

    const url = `https://api.whatsapp.com/send?phone=442038852600&text=Hi%20Tripmart%2C%20I%E2%80%99d%20like%20to%20know%20more%20about%20your%20travel%20packages.
`;
    window.open(url, '_blank');
  };
  const calladmin = () => {
    const phoneNumber = 'tel:02039449931'; 
    window.open(phoneNumber, '_self');
  };

  return (
    <>
    {/*-
    <div className="chat-component">
      <div className="messages">
      
      </div>

      <IoLogoWhatsapp className='icon-chat' onClick={handleWhatsAppClick}/>
    
    </div>
    -*/}
    <div className="chat-component2">
      <div className="messages">
        {/* Render messages here */}
      </div>

      
      <IoLogoWhatsapp className='icon-chat' onClick={handleWhatsAppClick}/>
    </div>
    </>
  );
};

export default Chat;
